import React, { FunctionComponent } from "react";
import { clsx } from "clsx";
import styles from "../llm-summary.module.scss";
import Typography from "../../../../../../../components/typography/Typography";
import Icon from "../../../../../../../components/Icon";
import { Link } from "../../../../../../../components/link";
import VerticalDivider from "../../../../../../../components/VerticalDivider";

type LLMSummarySidebarHeaderProps = {
  hasChanged?: boolean;
  shouldShowRefreshButton?: boolean;
  onRefreshClick?: () => void;
  onCloseClick?: () => void;
};

const LLMSummarySidebarHeader: FunctionComponent<
  LLMSummarySidebarHeaderProps
> = ({ hasChanged, shouldShowRefreshButton, onRefreshClick, onCloseClick }) => (
  <div className={styles.llm_summary_panel_header}>
    <Typography
      variant={"h5"}
      className={"text-white d-flex align-items-center gap-10"}
    >
      <Icon name={"ai-indicator"} />
      AI Summary
    </Typography>
    <div className={styles.llm_summary_panel_actions}>
      {hasChanged && (
        <Typography variant={"h5"} className={"text-white"}>
          Sample has changes:
        </Typography>
      )}
      {shouldShowRefreshButton && (
        <>
          <Link variant={"notification"} onClick={onRefreshClick}>
            <Typography variant={"h5"}>Refresh</Typography>
          </Link>
          <VerticalDivider
            className={clsx("m-0", styles.llm_summary_divider)}
          />
        </>
      )}
      <Icon
        name="close"
        size={16}
        color={"white"}
        onClick={onCloseClick}
        className={styles.llm_summary_panel_close}
      />
    </div>
  </div>
);

export default LLMSummarySidebarHeader;
